/* Wave Konfigurátor — zdieľané dáta s REÁLNYM cenníkom.
   Cena dielu = (gramy*0,01 + hodiny*0,56) * 1,05 (zmatkovanie) * 4,5 (marža 350%) * 1,23 (DPH).
   Lampa = VRCH + PODSTAVEC; krytka sa pridáva automaticky podľa podstavca. */
window.WAVE = {
  viewerUrl: 'https://kroma3d.app/view/printhiawave/',

  /* cenový vzorec (per diel, vracia cenu s DPH) */
  formula: { perGram: 0.01, perHour: 0.56, scrap: 1.05, margin: 4.5, vat: 1.23 },
  price: function (g, minutes) {
    var f = this.formula;
    return (g * f.perGram + (minutes / 60) * f.perHour) * f.scrap * f.margin * f.vat;
  },

  matteSurcharge: 1.00, // matný povrch na vrchu / podstavci (krytka zdarma)
  vat: 23,
  express: 24.00,     // expresná výroba do 24 h (s DPH), per lampa

  /* Dodanie — pracovné dni (výroba + odoslanie). Štandard 3-7, expres do 1. */
  delivery: { minDays: 3, maxDays: 7, expressWorkDays: 1 },

  /* Reálne fotky lampy (teplé / studené svetlo). Súbory dodá používateľ do /images. */
  photos: {
    warm: 'images/wave-tepla.jpg',
    cool: 'images/wave-studena.jpg'
  },

  /* VRCHY (tienidlá): g, minúty tlače, h = výška v cm (Z rozmer STL). Spolu 6.
     Všetky výšky reálne z STL. */
  tops: [
    { id: 'diamond', name: 'Diamond', g: 64, min: 240, h: 13 },
    { id: 'canopy',  name: 'Canopy',  g: 68, min: 243, ownBase: 'canopy', h: 12 },
    { id: 'flow',    name: 'Flow',    g: 89, min: 310, h: 13 },
    { id: 'rombus',  name: 'Rombus',  g: 61, min: 226, h: 13 },
    { id: 'tessera', name: 'Tessera', g: 59, min: 213, h: 12 },
    { id: 'torsion', name: 'Torsion', g: 69, min: 244, h: 12 }
  ],

  /* KRYTKY — vyberajú sa automaticky podľa podstavca */
  caps: {
    rebrovany1: { name: 'Krytka rebrovaný I',  g: 6,  min: 23 },
    rebrovany2: { name: 'Krytka rebrovaný II', g: 7,  min: 23 },
    led:        { name: 'Krytka LED Stand',    g: 17, min: 28.733 },
    miniled:    { name: 'Krytka Mini LED',     g: 16, min: 32.517 },
    canopy:     { name: 'Krytka Canopy',       g: 16, min: 30 }
  },

  /* PODSTAVCE: g, minúty, cap = id automatickej krytky, h = výška v cm (Z rozmer STL).
     Všetky spodky ~9 cm (90 mm). */
  bases: [
    { id: 'rebrovany1', name: 'Rebrovaný podstavec I',  g: 110, min: 221, cap: 'rebrovany1', h: 9 },
    { id: 'rebrovany2', name: 'Rebrovaný podstavec II', g: 107, min: 208, cap: 'rebrovany2', supports: true, h: 9 },
    { id: 'ledstand',   name: 'LED Stand',              g: 108, min: 168, cap: 'led', light: true, supports: true, h: 9 },
    { id: 'miniled',    name: 'Mini LED',               g: 40,  min: 62,  cap: 'miniled', light: true, h: 9 },
    { id: 'canopy',     name: 'Canopy podstavec',       g: 132, min: 196, cap: 'canopy', h: 9 }
  ],

  /* Napájanie — voliteľné. LED modul funguje LEN s LED podstavcami (LED Stand, Mini LED),
     objímky LEN s pasívnymi podstavcami (rebrovaný, canopy). */
  power: [
    { id: 'none',    label: 'Bez napájania',               sub: 'iba teleso lampy',                      add: 0,     icon: '' },
    { id: 'ledpuck', label: 'USB LED modul',               sub: 'bezdrôtové LED svetlo, USB',            add: 5.00,  was: 16.00, bundle: true, icon: '', forLight: true },
    { id: 'socket',  label: 'Objímka s káblom',            sub: 'kábel 1,8 m, E27 — zapojíš do zásuvky', add: 5.00,  hasSocketType: true, icon: '', forPassive: true },
    { id: 'dimmer',  label: 'Objímka s káblom + stmievač', sub: 'jas nastavíš priamo na kábli (E27)',    add: 12.00, isDimmer: true, icon: '', forPassive: true }
  ],
  socketTypes: ['E27', 'E14'],

  /* Žiarovka — voliteľná LED žiarovka */
  bulb: {
    add: 4.00, was: 6.00,
    watt: 2.2, lumen: 250,
    sockets: ['E27', 'E14'],
    temps: [
      { id: 'warm', label: 'Teplá biela 2700K', kelvin: '2700K' },
      { id: 'cool', label: 'Studená biela 6500K', kelvin: '6500K' }
    ]
  },

  maxLamps: 4,

  /* Bundle zľavy — 2 lampy = 7 %, 3+ lámp = 14 % na celú objednávku */
  bundle: [
    { min: 3, rate: 0.14 },
    { min: 2, rate: 0.07 }
  ],

  /* Farby dielov (vyberajú sa v 3D) */
  colors: [
    { name: 'Biela',        hex: '#FFFFFF' },
    { name: 'Piesková',     hex: '#E8DBB7' },
    { name: 'Nardo Gray',   hex: '#6E7174' },
    { name: 'Desert Tan',   hex: '#C19A6B' },
    { name: 'Cocoa Brown',  hex: '#6F5034' },
    { name: 'Čierna',       hex: '#111111' },
    { name: 'Tyrkysová',    hex: '#00B1B7' },
    { name: 'Fialová',      hex: '#5E43B7' },
    { name: 'Červená',      hex: '#D62828' },
    { name: 'Olivová',      hex: '#6B7A3F' }
  ],

  fmt: function (v) { return Number(v).toFixed(2).replace('.', ',') + ' €'; }
};
